import axios from "axios";
import { config } from "../config";

export const axiosInstance = axios.create({
  baseURL: config.API_BASE_URL,
  headers: {
    ContentType: "application/json",
  },
});
